import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import ZendeskOauthCredentialsStore from "../../../stores/credentials/zendesk-oauth-credentials-store";

interface IIntegrationProps {
    credentialsStore: ZendeskOauthCredentialsStore,
    vGroup: IValidationGroup,
}

const ZendeskOauthCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            As an initial step, please log into your Zendesk account in a separate browser tab.
            <FormFieldLine
                label='Subdomain'
                note='Enter your Zendesk subdomain. For example, if your Zendesk web address is https://myapp.zendesk.com, the subdomain would be "myapp".'
                required
                key='subdomain'
            >
                <Input
                    value={credentialsStore.subdomain}
                    placeholder=''
                    onChange={v => credentialsStore.subdomain = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Brand ID'
                note={<>Enter your Zendesk Brand ID. <a target="_blank" href="https://support.zendesk.com/hc/en-us/articles/6606906179098-How-can-I-identify-brand-IDs-in-a-multi-brand-setup" rel="noreferrer">How can I identify my brand ID?</a></>}
                key='brandid'
            >
                <Input
                    value={credentialsStore.brandId}
                    placeholder=''
                    onChange={v => credentialsStore.brandId = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    )
});

export default ZendeskOauthCredentials;
